var React = require('react');

function Guide (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icoGuide"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"icoGuide","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M9.324,5.526 L5.25,7.85 L5.25,3.174 L9.324,5.526 Z M12.25,9.026 L12.25,2.026 L1.75,2.026 L1.75,9.026 L12.25,9.026 Z M12.25,0.85 C12.5673349,0.85 12.8426655,0.96433219 13.076,1.193 C13.3093345,1.42166781 13.426,1.6993317 13.426,2.026 L13.398,9.026 C13.398,9.34333492 13.2860011,9.61399888 13.062,9.838 C12.8379989,10.0620011 12.5673349,10.174 12.25,10.174 L9.324,10.174 L9.324,11.35 L4.676,11.35 L4.676,10.174 L1.75,10.174 C1.4233317,10.174 1.14566781,10.0620011 0.917,9.838 C0.68833219,9.61399888 0.574,9.34333492 0.574,9.026 L0.574,2.026 C0.574,1.6993317 0.68833219,1.42166781 0.917,1.193 C1.14566781,0.96433219 1.4233317,0.85 1.75,0.85 L12.25,0.85 Z","id":"ondemand_video---material","fill":"#FFFFFF"}))]);
}

Guide.defaultProps = {"width":"14px","height":"12px","viewBox":"0 0 14 12","version":"1.1"};

module.exports = Guide;

Guide.default = Guide;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/guide.svg
// module id = 928
// module chunks = 0